import { supabase } from './client';

export const getBrands = async (q: string | null = null): Promise<string[]> => {
  try {
    let query = supabase.from('brands').select('name').order('name');
    if (q) {
      query = query.ilike('name', `%${q}%`);
    }
    const { data, error } = await query;
    if (error) throw error;
    return Array.isArray(data) ? data.map((d: any) => d.name) : [];
  } catch (err) {
    console.error('getBrands error', err);
    return [];
  }
};

export const createBrand = async (name: string) => {
  const { data, error } = await supabase.from('brands').insert({ name }).select().single();
  if (error) throw error;
  return data;
};

export const getModels = async (brand: string | null = null, q: string | null = null): Promise<Array<{ brand: string; model: string }>> => {
  try {
    if (brand) {
      const { data, error } = await supabase.from('models').select('brand,model').eq('brand', brand).order('model');
      if (error) throw error;
      let arr = Array.isArray(data) ? data.map((d: any) => ({ brand: d.brand, model: d.model })) : [];
      if (q) {
        const lower = q.toLowerCase();
        arr = arr.filter(x => x.model.toLowerCase().includes(lower));
      }
      return arr;
    }

    // No brand: search models table for q or return limited list
    const { data, error } = await supabase.from('models').select('brand,model').order('brand,model').limit(200);
    if (error) throw error;
    let arr = Array.isArray(data) ? data.map((d: any) => ({ brand: d.brand, model: d.model })) : [];
    if (q) {
      const lower = q.toLowerCase();
      arr = arr.filter(x => x.model.toLowerCase().includes(lower) || x.brand.toLowerCase().includes(lower));
    }
    return arr;
  } catch (err) {
    console.error('getModels error', err);
    return [];
  }
};

export const createModel = async (brand: string, model: string) => {
  const { data, error } = await supabase.from('models').insert({ brand, model }).select().single();
  if (error) throw error;
  return data;
};

export default null;
